import React from "react";

export default function PrivacyPolicyEn() {
  return (
    <>
      <h1>PRIVACY POLICY</h1>
      <p>
        <strong>Last Updated:</strong> June 2026
      </p>

      <p>
        At <strong>LigaVirtualF1</strong>, we take your privacy very seriously.
        This Privacy Policy describes how we collect, use, and protect the
        personal information you provide when registering on our website{" "}
        <a
          href="https://ligavirtualf1.es/en"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ligavirtualf1.es/en
        </a>
        , in compliance with the EU General Data Protection Regulation (GDPR)
        and applicable Spanish legislation.
      </p>

      <hr
        style={{
          border: "0",
          height: "1px",
          background: "#ccc",
          margin: "20px 0",
        }}
      />

      <h3>1. DATA CONTROLLER</h3>
      <p>
        The data controller responsible for your data is the administration of
        the <strong>LigaVirtualF1</strong> community. As a recreational,
        non-profit community with no commercial legal entity, you can contact
        the main administrator for any questions, inquiries, or to exercise your
        rights through the community's official email or internal support
        channels.
      </p>

      <h3>2. DATA WE COLLECT</h3>
      <p>
        When you register on our platform, we collect the following personal
        data:
      </p>
      <ul>
        <li>
          <strong>Required Data:</strong> First name, last name, username
          (Nick), email address, country (and autonomous community if Spain is
          selected), password (encrypted), and how you found out about us.
        </li>
        <li>
          <strong>Optional Data:</strong> Date of birth and profile picture
          (avatar).
        </li>
      </ul>

      <h3>3. PURPOSE OF DATA PROCESSING</h3>
      <p>
        We use the collected information exclusively for the following purposes:
      </p>
      <ul>
        <li>
          To manage your user registration, driver profile, and your
          participation in the championships organized by the community.
        </li>
        <li>
          To display your username, country/autonomous community, and race
          statistics on leaderboards and public results pages on a historical
          basis.
        </li>
        <li>
          To broadcast and publish races on streaming platforms (such as
          YouTube, Twitch, or TikTok). By participating in the official
          championships of the Community, you accept that your username and
          telemetry will appear in such audiovisual content.
        </li>
        <li>
          To send you technical notifications or important announcements related
          to the league via email.
        </li>
      </ul>

      <h3>4. LAWFUL BASIS FOR PROCESSING</h3>
      <p>
        The legal basis for processing your data is the{" "}
        <strong>explicit consent</strong> you grant us by checking the
        acceptance box of this policy during the registration process.
      </p>

      <h3>5. DATA RETENTION AND PERSISTENCE OF SPORTS DATA</h3>
      <p>
        We will retain your profile data as long as your account remains active.
        If you decide to leave the community or request account cancellation,
        please note that for reasons of competition integrity, general
        statistics, and legitimate historical interest,{" "}
        <strong>
          your race results, times, standings, and sports records on the website
          will remain permanently visible
        </strong>
        . They may remain linked to your former username or be anonymized, but
        they will never be deleted so as not to alter the history of the
        championships. Furthermore, already published audiovisual content (race
        broadcasts on YouTube/TikTok) will not be removed or edited.
      </p>

      <h3>6. RECIPIENTS AND DATA DISCLOSURE</h3>
      <p>
        LigaVirtualF1 <strong>does not sell, rent, or share</strong> your
        personal data with third-party companies or organizations. Your data
        remains secure on the servers hosting our website.
      </p>
      <p>
        Please note that by participating in an online league, your username,
        avatar, and race statistics will be public and visible to other internet
        users within the standings and broadcast sections of the website.
      </p>

      <h3>7. YOUR RIGHTS AND LIMITATIONS</h3>
      <p>
        The GDPR grants you rights of Access, Rectification, Restriction, and
        Objection. However, the Right to Erasure (Right to be Forgotten) is
        subject to limitations on our platform due to the competitive nature of
        the activity:
      </p>
      <ul>
        <li>
          You may request the deletion of your personal contact data (such as
          your email or private profile data), which will result in immediate
          termination of your account.
        </li>
        <li>
          <strong>Limitation:</strong> The right to erasure DOES NOT apply to
          race results, historical standings, or video recordings of
          competitions in which you participated, as their removal would harm
          the historical record of the community and the rights of the other
          participants.
        </li>
      </ul>
      <p>
        To request account cancellation or modify your data, you can contact the
        administration through our official channels.
      </p>

      <h3>8. DATA SECURITY</h3>
      <p>
        We implement necessary technical security measures (such as password
        encryption and secure HTTPS connections) to protect your data against
        unauthorized access, loss, or alteration. However, please remember that
        no transmission over the Internet is 100% secure.
      </p>
    </>
  );
}
